import React from 'react';
import { BookOpenIcon, CalendarIcon, ClockIcon, CreditCardIcon, FileTextIcon, GiftIcon, LockIcon, PrinterIcon, ShieldCheckIcon, StarIcon, UsersIcon } from 'lucide-react';
import { mockupUrl } from '../data/content';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative overflow-hidden px-4 pb-14 pt-9 md:pb-20 md:pt-16" data-id="element-229" data-mp="4mrul1r1q1lr">
      <div className="pointer-events-none absolute left-1/2 top-[18%] h-[540px] w-[540px] -translate-x-1/2 rounded-full bg-accent/10 blur-[110px]" data-id="element-230" data-mp="12a0j75mcfqrz" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-231" data-mp="xb5whsl99i2l">
        <div className="mb-5 inline-flex rounded-full border border-accent/20 bg-accent/10 px-4 py-1.5 font-display text-[11px] font-bold uppercase tracking-wider text-primary md:mb-7" data-id="element-232" data-mp="sa9r1al99nv2">
          🏋️ CompraDigitalYa™
        </div>
        <h1 className="mx-auto max-w-4xl text-[1.75rem] font-extrabold leading-[1.1] tracking-tight text-slate-900 md:text-6xl" data-id="element-233" data-mp="3d2tqpg8vwwhp">
          Tu sistema de entrenamiento para adultos mayores,{' '}
          <span className="text-accent" data-id="element-234" data-mp="3j9ai9gc8yw6q">listo desde hoy.</span>
        </h1>
        <a href="#pricing" className="group my-5 flex justify-center rounded-3xl focus:outline-none md:my-7" aria-label="Ver las opciones de compra del Combo Completo Entrenamiento para Adultos Mayores" data-id="element-235" data-mp="3o6kh1mlj0k78">
          <img className="w-full max-w-[620px] object-contain drop-shadow-[0_24px_38px_rgba(234,88,12,.22)] transition-transform duration-300 group-hover:scale-[1.015]" src={mockupUrl} alt="Mockup del Combo Completo Entrenamiento para Adultos Mayores con sus 6 tomos y 6 bonos" data-id="element-236" data-mp="3eb8zkwiqgyvs" />
        </a>
        <p className="mx-auto max-w-3xl text-base font-medium leading-relaxed text-slate-600 md:text-xl" data-id="element-237" data-mp="2vi53l4i1m9y0">
          <strong className="text-slate-900" data-id="element-238" data-mp="2hix4eblvr1tt">
            COMBO COMPLETO ENTRENAMIENTO PARA ADULTOS MAYORES.
          </strong>{' '}
          El sistema N°1 para profesores de educación física, entrenadores personales, kinesiólogos
          y centros de jubilados que necesitan un programa real, progresivo y listo para aplicar con
          adultos mayores en Argentina.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs font-medium text-slate-600 md:text-sm" data-id="element-239" data-mp="ibp18tl572yl">
          <span className="flex items-center gap-1.5" data-id="element-240" data-mp="de6rj0zawjpj">
            <FileTextIcon className="h-4 w-4 text-accent" data-id="element-241" data-mp="1b0vupe5qp2cz" />
            100% PDF
          </span>
          <span className="flex items-center gap-1.5" data-id="element-242" data-mp="161t1cqz4gkku">
            <ClockIcon className="h-4 w-4 text-accent" data-id="element-243" data-mp="162c9xh2vtwm7" />
            Acceso en 5 min
          </span>
          <span className="flex items-center gap-1.5" data-id="element-244" data-mp="111507ch6incw">
            <CalendarIcon className="h-4 w-4 text-accent" data-id="element-245" data-mp="x1nuqj1r5q7q" />
            Edición 2025
          </span>
          <span className="flex items-center gap-1.5" data-id="element-246" data-mp="3ltgmlp4rwont">
            <PrinterIcon className="h-4 w-4 text-accent" data-id="element-247" data-mp="3lu9tqr7n9g6h" />
            Listo para usar hoy
          </span>
        </div>
        <div className="mt-7" data-id="element-248" data-mp="1x9b3owgzwtag">
          <Button href="#pricing" className="w-full text-sm md:w-auto md:px-10 md:py-5 md:text-lg" data-id="element-249" data-mp="1xa429a5swchi">
            QUIERO EL SISTEMA COMBO COMPLETO ADULTOS MAYORES
          </Button>
        </div>
        <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] font-medium text-slate-500 md:text-sm" data-id="element-250" data-mp="269hcw65nv73t">
          <span className="flex items-center gap-1" data-id="element-251" data-mp="2b1hj2gcbqw8u">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-accent" data-id="element-252" data-mp="2g02kuk785nze" />
            Garantía 7 días
          </span>
          <span className="text-orange-300" data-id="element-253" data-mp="2kydtwspp3ugk">·</span>
          <span className="flex items-center gap-1" data-id="element-254" data-mp="2kx2hk4i6pedu">
            <LockIcon className="h-3.5 w-3.5 text-accent" data-id="element-255" data-mp="2p08ufuzsy3ta" />
            Pago seguro
          </span>
          <span className="text-orange-300" data-id="element-256" data-mp="2tztte5ez2c60">·</span>
          <span className="flex items-center gap-1" data-id="element-257" data-mp="2txhczwov49v2">
            <CreditCardIcon className="h-3.5 w-3.5 text-accent" data-id="element-258" data-mp="unj0jd9foulw" />
            Mercado Pago
          </span>
        </div>
        <div className="mt-10 grid grid-cols-2 gap-3 md:mt-14 md:grid-cols-4" data-id="element-259" data-mp="zm2nngzrkcfu">
          <TrustCard icon={<UsersIcon className="h-5 w-5 text-accent" data-id="element-261" data-mp="49jbw1ixchkj" />} text="+300 profesionales ya usan el sistema" data-id="element-260" data-mp="4acmxeox1t8h" />
          <TrustCard icon={<BookOpenIcon className="h-5 w-5 text-accent" data-id="element-263" data-mp="ea3gne5nk47i" />} text="6 Tomos listos para usar" data-id="element-262" data-mp="3vk1n8a7amn31" />
          <TrustCard icon={<GiftIcon className="h-5 w-5 text-accent" data-id="element-265" data-mp="9b8npjdz0z9o" />} text="6 Bonos incluidos gratis" data-id="element-264" data-mp="9bihzj61tsl6" />
          <TrustCard icon={<StarIcon className="h-5 w-5 fill-gold text-gold" data-id="element-267" data-mp="3crftpwjuz8lm" />} text="4,9/5 · ★★★★★" data-id="element-266" data-mp="3ho69sjvny471" />
        </div>
      </div>
    </section>;
}
function TrustCard({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex flex-col items-center gap-2 rounded-2xl border border-orange-100 bg-white p-3 shadow-sm" data-id="element-268" data-mp="3mollz847l5nf">
      <span data-id="element-269" data-mp="2yxyaydyzxzwn">{icon}</span>
      <span className="text-center text-[11px] font-bold leading-tight text-slate-800 md:text-sm" data-id="element-270" data-mp="2u0ppa3en3dqn">
        {text}
      </span>
    </div>;
}